import React, {useEffect, useRef, useState} from 'react';
import {mrbgStore} from './mrbgRedux';
import mrbgS2S from '../../mrbgLib/mrbgS2S.js';
import {Mrbg} from '../../mrbgLib/Mrbg.js';

function MrbgWs({asideStyle}){
	const
		connectAudio = useRef(new Audio('/webSocket/notifSound/connection.wav')),
		notifAudio = useRef(new Audio('/webSocket/notifSound/notification.wav')),
		socketRef             = useRef(null),
		[iconCls, setIconCls] = useState(`fa-regular fa-power-off ${asideStyle.offline}`),
		manualDisconnect = useRef(false);

	function handleConnection(){
		if( socketRef.current ){
			socketRef.current.close();
			manualDisconnect.current = true;
		}
		else{
			const
				empInfo  = mrbgStore.getState().__TK?.EP || {},
				userID   = empInfo?.id,
				userDev  = empInfo.devID,
				userType = empInfo.empType,
				site     = 'candela';
			socketRef.current = new WebSocket(`ws://localhost:8080/?site=${site}&userID=${userID}&userDev=${userDev}&userType=${userType}`);
			setIconCls(`fa-regular fa-refresh ${asideStyle.connecting}`);
			manualDisconnect.current = false;

			socketRef.current.onopen = () => {
				setIconCls(`fa-regular fa-power-off ${asideStyle.online}`);
				connectAudio.current.play().catch(() => {});
				mrbgS2S(null, new FormData(), 'notif', 'load', false);
			};

			socketRef.current.onmessage = async( event ) => {
				try{
					let text = event.data;
					if( event.data instanceof Blob ){
						text = await event.data.text();
					}

					var parsed = JSON.parse(text);
					if( Object.hasOwn(parsed, '__NT') ){
						const
							oldList = mrbgStore.getState().myNotifications || {};

						for( let apoSesID of Object.keys(parsed.__NT) ){
							if( !Object.hasOwn(oldList,apoSesID) || JSON.stringify(parsed.__NT[apoSesID])!==JSON.stringify(oldList[apoSesID]) ){
								notifAudio.current.play().catch(() => {});
								break;
							}
						}
					}

					Mrbg.successRequest(null, parsed);
				}
				catch( e ){
					console.warn('📩 پیام متنی ساده یا JSON نامعتبر:', event.data, e);
				}
			};

			socketRef.current.onerror = ( error ) => {
				setIconCls(`fa-regular fa-power-off ${asideStyle.offline}`);
				console.error('❌ خطای WebSocket:', error);
			};

			socketRef.current.onclose = () => {
				setIconCls(`fa-regular fa-power-off ${asideStyle.offline}`);
				socketRef.current = null; // ✅ ریست بعد از قطع اتصال
				if( !manualDisconnect.current )
					setTimeout(() => {
					handleConnection();
				}, 2000);
			};
		}
	}

	useEffect(() => {
		const unlockAudio = () => {
			notifAudio.current.volume = 0;

			notifAudio.current.play()
				.then(() => {
					notifAudio.current.pause();
					notifAudio.current.currentTime = 0;
					notifAudio.current.volume = 1;
				})
				.catch(() => {});

			document.removeEventListener('click', unlockAudio);
		};
		// // handleConnection();
		document.addEventListener('click', unlockAudio);

		return () => {
			document.removeEventListener('click', unlockAudio);
			if( socketRef.current ){
				socketRef.current.close();
			}
		};
	}, []);

	return (
		<i className={iconCls} onClick={handleConnection}></i>
	);
}

export default MrbgWs;